var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "DialogLinkBankTask", attrs: { dir: "rtl" } },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { width: "460px" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("שיוך משימה מהבנק"),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("div", { staticClass: "course-context" }, [
                _vm._v(" שיוך לקורס הנוכחי: "),
                _c("strong", [_vm._v(_vm._s(_vm.courseName))]),
              ]),
              _c(
                "b-field",
                { attrs: { label: "משימה מהבנק" } },
                [
                  _c("FieldInlineSelect", {
                    attrs: {
                      label: "בחירת משימה",
                      placeholder: "הקלד שם / מזהה משימה לחיפוש בבנק",
                      "alert-not-exist": true,
                      "hide-hover": true,
                      clearable: true,
                      filterable: true,
                      options: [],
                      "fetch-options": _vm.onSearchTasks,
                    },
                    on: { onChange: _vm.onChange },
                    model: {
                      value: _vm.taskId,
                      callback: function ($$v) {
                        _vm.taskId = $$v
                      },
                      expression: "taskId",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "note" }, [
                _vm._v(
                  "המשימה תשויך לקורס. שיוך חוזר של משימה שכבר משויכת אינו יוצר כפילות."
                ),
              ]),
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  loading: _vm.isLoading,
                  disabled: _vm.taskId == null,
                  type: "is-primary",
                  label: "שייך משימה",
                },
                on: { click: _vm.save },
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isLoading, label: "ביטול" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }